/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * enum value for quick action alignment
 * @public
 */
export var QuickActionsStackVariant;
(function (QuickActionsStackVariant) {
    QuickActionsStackVariant["HORIZONTAL"] = "HORIZONTAL";
    QuickActionsStackVariant["VERTICAL"] = "VERTICAL";
})(QuickActionsStackVariant || (QuickActionsStackVariant = {}));
//# sourceMappingURL=chatTypes.js.map